module.exports = __webpack_public_path__ + "img/discovery.3188edb8.png";